import { configureStore, Action, ThunkDispatch, AnyAction, applyMiddleware, createStore } from "@reduxjs/toolkit"
import { mainSliceReducer } from "./main/mainSlice"
import { ThunkAction } from "redux-thunk"
import { IMainState } from "./main/mainSlice"
import { TypedUseSelectorHook, useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { PersistConfig, persistReducer, persistStore } from "redux-persist";
import logger from "redux-logger";
import storage from 'redux-persist/lib/storage';

// The AppThunk type will help us in writing type definitions for thunk actions
export type AppThunk = ThunkAction<void, IMainState, unknown, Action<string>>;

const mainPersistConfig: PersistConfig<IMainState, any, any, any> = {
  key: "mainStore",
  storage,
  whitelist: [],
  // whitelist: ['userId', 'adminId', 'isAdmin', 'adminName'],
};

const reducer = {
  mainStore: persistReducer(mainPersistConfig, mainSliceReducer),
}

export const store = configureStore({
  reducer, 
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>
export type AppThunkDispatch = ThunkDispatch<RootState, any, AnyAction>;
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = () => useDispatch<AppThunkDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;